import React from 'react';
import {connect, DispatchProp, useSelector} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as StarIco} from "../../../../../images/icons/star.svg";
import {RootState} from "../../../../../reducers";
import Money from "../../../../components/Common/Money";
import {getItems} from "../../../../services/Menu/reducer";
import {getCartTotal} from "../../../../services/Cart/reducer";
import {getUser, getVouchers} from "../../../../services/User/reducer";


interface OwnProps {
    promotions: any
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuPromotionsComponent = (props: Props) => {
    const {t} = useTranslation();
    const cartTotal = props.cartTotal;
    let promotions = props.promotions;

    if ((promotions === undefined || !promotions || promotions.length === 0) && !props.user) {
        return null;
    }

    let totalPriceAmount = cartTotal ? cartTotal.amount : 0;
    let promotionsToGet = promotions.filter((x: any) => x.min_basket_money && x.min_basket_money.amount > totalPriceAmount);

    return (
        <div className={"container promotions"}>
            {promotionsToGet.map((promotion: any) => {
                return (
                    <button key={promotion.id} className={"btn btn-promotion"}>
                        <div className={"star"}>
                            <StarIco/>
                        </div>
                        <div className={"content"}>
                            {promotion.name}
                            <small>
                                {`${t("modules.menu.field.min_cart_value.title")}: `} <Money value={promotion.min_basket_money}/>
                            </small>
                        </div>
                    </button>
                )
            })}
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    user: getUser(state.user),
    vouchers: getVouchers(state.user),
    cartTotal: getCartTotal(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuPromotionsComponent));